module.exports = __webpack_public_path__ + "static/media/move.15f651a7.svg";